import {
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Radio,
  RadioGroup,
  Rating,
  Typography
} from '@mui/material'
import React, { useState } from 'react'
import { useTheme } from '@mui/styles'
import FormLabel from '@mui/material/FormLabel'
import {
  TextBold,
  TextRegular,
  TextSemiBold
} from '../../../commonComponents/TextStyling'

import { isEmpty, showToast } from '../../../utils/AppHelper'
import { useLocation, useNavigate } from 'react-router-dom'
import serverData from '../../../api/ServerData'
import AppButton from '../../../commonComponents/AppButton'

export default function RecruiterFeedback ({ candidateState, changeState }) {
  const [state, setState] = useState(1)

  const location = useLocation()
  const navigate = useNavigate()

  const [loadingBtn, setLoadingBtn] = useState(false)

  const [comeToKnowAboutJob, setcomeToKnowAboutJob] = useState('')
  const [communicatedVia, setCommunicatedVia] = useState([])
  const [rating, setRating] = useState(1)

  const query = new URLSearchParams(location.search)
  const token = query.get('token')

  var theme = useTheme()

  return (
    <Grid container>
      <Grid container textAlign={'center'}>
        <Grid item xs={12}>
          <TextBold style={{ fontSize: '22px' }}>
            Can you tell us about the recruiter?
            <span
              style={{
                fontSize: '12px',
                fontWeight: 300,
                marginLeft: '5px'
              }}
            >
              Optional
            </span>
          </TextBold>
        </Grid>
        <Grid item xs={12}>
          <TextRegular>
            Please help us improve the recruiting process. We have three simple
            questions about your experience working with{' '}
            {candidateState.recruiterFirstName}{' '}
            {candidateState.recruiterLastName}. This information will not be
            shared with the recruiter.
          </TextRegular>
        </Grid>
      </Grid>

      <Divider
        style={{
          width: '100%',
          margin: '24px 0px'
        }}
      />

      <Grid
        item
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: `1px solid ${theme.palette.border.main}`,
          width: '6rem',
          height: '6rem',
          borderRadius: '16px',
          overflow: 'hidden',
          padding: '8px',
          marginRight: '16px'
        }}
      >
        <TextRegular
          style={{
            fontSize: '34px'
          }}
        >
          {candidateState?.recruiterFirstName?.substring(0, 1).toUpperCase()}
          {candidateState?.recruiterLastName?.substring(0, 1).toUpperCase()}
        </TextRegular>
      </Grid>

      <Grid
        item
        style={{
          display: 'flex',
          width: '79%',
          alignItems: 'center'
        }}
      >
        <Grid container direction={'column'}>
          <Grid item>
            <TextBold style={{ fontSize: '20px' }}>
              {candidateState.recruiterFirstName.charAt(0).toUpperCase() +
                candidateState.recruiterFirstName.slice(1)}{' '}
              {candidateState.recruiterLastName.charAt(0).toUpperCase() +
                candidateState.recruiterLastName.slice(1)}
            </TextBold>
          </Grid>
          <Grid item>
            <TextRegular style={{ fontSize: '12px' }}>
              {candidateState.recruiterPhone}
            </TextRegular>
            <TextRegular
              style={{
                fontSize: '12px',
                margin: '0px 6px'
              }}
            >
              |
            </TextRegular>
            <TextRegular style={{ fontSize: '12px' }}>
              {candidateState.recruiterEmail}
            </TextRegular>
          </Grid>
        </Grid>
      </Grid>

      <Divider
        style={{
          width: '100%',
          margin: '24px 0px'
        }}
      />

      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={12}>
            <FormControl>
              <FormLabel id='demo-radio-buttons-group-label'>
                <TextSemiBold style={{ fontSize: 16 }}>
                  1. How did you come to know about the{' '}
                  {candidateState.jobTitle} - {candidateState.city},{' '}
                  {candidateState.state}, {candidateState.countryName}?
                </TextSemiBold>
              </FormLabel>
              <RadioGroup
                aria-labelledby='demo-radio-buttons-group-label'
                name='radio-buttons-group'
                value={comeToKnowAboutJob}
                onChange={event => setcomeToKnowAboutJob(event.target.value)}
                style={{ margin: 16 }}
              >
                {[
                  {
                    label: `${
                      candidateState.recruiterFirstName
                        .charAt(0)
                        .toUpperCase() +
                      candidateState.recruiterFirstName.slice(1)
                    } sent me an email about the job opening`
                  },
                  {
                    label: `I applied to a job online and then ${
                      candidateState.recruiterFirstName
                        .charAt(0)
                        .toUpperCase() +
                      candidateState.recruiterFirstName.slice(1)
                    } reached out`
                  },
                  {
                    label: `${
                      candidateState.recruiterFirstName
                        .charAt(0)
                        .toUpperCase() +
                      candidateState.recruiterFirstName.slice(1)
                    } called me to inquire if i was interested in the role`
                  },
                  {
                    label: `${
                      candidateState.recruiterFirstName
                        .charAt(0)
                        .toUpperCase() +
                      candidateState.recruiterFirstName.slice(1)
                    } sent me a LinkedIn message`
                  },
                  { label: "I don't remember" },
                  { label: 'Other' }
                ].map(item => (
                  <FormControlLabel
                    value={item.label}
                    control={<Radio />}
                    label={item.label}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl>
              <FormLabel id='demo-radio-buttons-group-label'>
                <TextSemiBold style={{ fontSize: 16 }}>
                  2. How did you and {candidateState.candidateFirstName}{' '}
                  communicate?
                </TextSemiBold>
              </FormLabel>

              <FormGroup style={{ margin: 16 }}>
                {[
                  { label: 'Phone call', value: 'phonecall' },
                  { label: 'Text message', value: 'textmessage' },
                  { label: 'Email', value: 'email' },
                  { label: 'LinkedIn', value: 'linkedin' },
                  { label: "I don't remember", value: 'idonotremember' },
                  { label: 'Other', value: 'other' }
                ].map((item, index) => {
                  var isSelectedIndex = communicatedVia.findIndex(
                    e => e === item.value
                  )
                  return (
                    <FormControlLabel
                      key={index}
                      control={
                        <Checkbox
                          checked={isSelectedIndex !== -1}
                          value={item.value}
                          onChange={event => {
                            const { value } = event.target
                            if (isSelectedIndex !== -1) {
                              var data = [...communicatedVia]
                              data.splice(isSelectedIndex, 1)
                              setCommunicatedVia(data)
                            } else {
                              setCommunicatedVia(prev => [...prev, value])
                            }
                          }}
                        />
                      }
                      label={item.label}
                    />
                  )
                })}
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Typography component='legend'>
              <TextSemiBold style={{ fontSize: 16 }}>
                3. How would you rate your overall experience working with{' '}
                {candidateState.recruiterFirstName.charAt(0).toUpperCase() +
                  candidateState.recruiterFirstName.slice(1)}{' '}
                {candidateState.recruiterLastName.charAt(0).toUpperCase() +
                  candidateState.recruiterLastName.slice(1)}
                ?
              </TextSemiBold>
            </Typography>
            <Rating
              style={{ margin: 24 }}
              name='simple-controlled'
              size={'large'}
              value={rating}
              onChange={(event, newValue) => {
                setRating(newValue)
              }}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: 0
        }}
      >
        <Divider
          style={{
            width: '100%',
            paddingLeft: 0,
            margin: '24px 0px'
          }}
        />
      </Grid>

      <Grid
        container
        alignItems={'center'}
        style={{
          display: 'flex',
          justifyContent: 'space-evenly',
          alignItems: 'center'
        }}
      >
        <Grid
          item
          style={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <AppButton
            name={'Send private feedback'}
            disabled={
              isEmpty(comeToKnowAboutJob) ||
              communicatedVia.length === 0 ||
              isEmpty(rating)
            }
            loading={loadingBtn}
            onClick={() => {
              setLoadingBtn(true)
              var body = {
                token: token,
                comeToKnowAboutJob: comeToKnowAboutJob,
                communicatedVia: communicatedVia.join(', '),
                rating: rating
              }
              serverData.feedbackOnRecruiter(
                body,
                data => {
                  if (data?.status) {
                    changeState(4)
                  } else {
                    navigate('/')
                  }
                  setLoadingBtn(false)
                },
                error => {
                  setLoadingBtn(false)
                  showToast(error.statusText)
                }
              )
            }}
          />
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Button
            variant='text'
            style={{
              textTransform: 'none',
              textDecoration: 'underline'
            }}
            onClick={() => navigate('/')}
          >
            skip these question
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}
